// module_configs/pharmacy.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faPills, faUsersCog, faClock, faTriangleExclamation,
  faHourglassHalf, faBan, faGift, faTags, faTrashCan, faArrowTrendDown,
  faBoxesStacked, faSquarePlus, faPuzzlePiece
} from '@fortawesome/free-solid-svg-icons';

// Import Pharmacy components
import PharmacyDashboardHome from '.././module_pharmacy/pharmacy_DashHome';

import PharmacyAddCustomer from '.././module_pharmacy/pharmacy_customer';

import PharmacyCustomersListjsx from '.././module_pharmacy/pharmacy_customer_list';

import PharmacyAddSupplier from '.././module_pharmacy/pharmacy_Supplier';

import PharmacySupplierList from '.././module_pharmacy/pharmacy_SuppliersList';

import PharmacyAddEmployee from '.././module_pharmacy/pharmacy_employees';

import PharmacyEmployeeList from '.././module_pharmacy/pharmacy_employeelist';

import AddPharmacyItem from '.././module_pharmacy/pharmacy_items';

import PharmacyItemsList from '.././module_pharmacy/pharmacy_itemslist';

import PharmacyProduct from '.././module_pharmacy/pharmacy_Products';

import PharmacyProductsList from '.././module_pharmacy/pharmacy_ProductsList';

import PharmacyPurchases from '.././module_pharmacy/pharmacy_Purchases';

import PharmacyPurchaseList from '.././module_pharmacy/pharmacy_PurchaseList';

import PharmacyPurchasesbySupplier from '.././module_pharmacy/pharmacy_PurchasesbySupplier';

import PharmacyReturn from '.././module_pharmacy/pharmacy_Return';

import PharmacyReturnList from '.././module_pharmacy/pharmacy_ReturnList';

import PharmacySell from '.././module_pharmacy/pharmacy_Sell';

import PharmacySalesList from '.././module_pharmacy/pharmacy_SellList';

import PharmacyTransactionsManager from '.././module_pharmacy/pharmacy_transactions';

import PharmacyBarcode from '.././module_pharmacy/pharmacy_BarcodeGenerator';

import PharmacyBonusProducts from '.././module_pharmacy/pharmacy_BonusProducts';

import PharmacyExpiredProducts from '.././module_pharmacy/pharmacy_ExpiredProducts';

import PharmacySoonExpiredProducts from '.././module_pharmacy/pharmacy_ExpiringProducts';

import PharmacyOutProducts from '.././module_pharmacy/pharmacy_OutProducts';

import PharmacyLowStockProducts from '.././module_pharmacy/pharmacy_LowStock';

import PharmacyProductsDiscounts from '.././module_pharmacy/pharmacy_Discounts';

import PharmacyDisposedProducts from '.././module_pharmacy/pharmacy_ExposedProducts';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

export const pharmacyConfig = {
  moduleId: 'pharmacy',
  moduleName: 'Pharmacy',
  icon: faPills,
  description: 'Pharmacy & Medical Store Management System',
  
  dashboardComponent: PharmacyDashboardHome,
  
  roles: {
    'admin_pharmacy': { level: 1, label: 'Admin', color: '#10b981' },
    'manager_pharmacy': { level: 2, label: 'Manager', color: '#059669' },
    'user_pharmacy': { level: 3, label: 'User', color: '#047857' },
    'viewer_pharmacy': { level: 4, label: 'Viewer', color: '#065f46' },
    'admin_pharmacytax': { level: 1, label: 'Admin (TAX)', color: '#34d399' },
    'manager_pharmacytax': { level: 2, label: 'Manager (TAX)', color: '#10b981' },
    'user_pharmacytax': { level: 3, label: 'User (TAX)', color: '#059669' },
    'viewer_pharmacytax': { level: 4, label: 'Viewer (TAX)', color: '#047857' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 4 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: PharmacyDashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: PharmacyAddCustomer,
          icon: faUserPlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: PharmacyCustomersListjsx,
          icon: faUsersLine,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: PharmacyAddSupplier,
          icon: faUserTie,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: PharmacySupplierList,
          icon: faBuildingUser,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        }
      ]
    },
    {
      id: 'items',
      label: 'Items',
      icon: faPuzzlePiece,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      groupId: 'inventory',
      position: 3,
      submenus: [
        {
          id: 'newitem',
          label: 'Add Item',
          component: AddPharmacyItem,
          icon: faSquarePlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'itemslist',
          label: 'Items List',
          component: PharmacyItemsList,
          icon: faListAlt,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        }
      ]
    },
    {
      id: 'stock',
      label: 'Stock',
      icon: faBoxesStacked,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addstock',
          label: 'Add Stock',
          component: PharmacyProduct,
          icon: faSquarePlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: PharmacyProductsList,
          icon: faClipboardList,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'discounts',
          label: 'TP%, Extra%',
          component: PharmacyProductsDiscounts,
          icon: faTags,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'bonusproducts',
          label: 'Bonus Stock',
          component: PharmacyBonusProducts,
          icon: faGift,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'lowstock',
          label: 'Low Stock',
          component: PharmacyLowStockProducts,
          icon: faArrowTrendDown,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'outofstock',
          label: 'Out of Stock',
          component: PharmacyOutProducts,
          icon: faBan,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'expiringproducts',
          label: 'Expiring Stock',
          component: PharmacySoonExpiredProducts,
          icon: faHourglassHalf,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'expiredproducts',
          label: 'Expired Stock',
          component: PharmacyExpiredProducts,
          icon: faTriangleExclamation,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'disposedstock',
          label: 'Disposed Stock',
          component: PharmacyDisposedProducts,
          icon: faTrashCan,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      groupId: 'sales',
      position: 5,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: PharmacySell,
          icon: faCartPlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: PharmacySalesList,
          icon: faClipboardList,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      groupId: 'inventory',
      position: 6,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: PharmacyPurchases,
          icon: faCartPlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: PharmacyPurchaseList,
          icon: faFileInvoice,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'purchasesbysupplier',
          label: 'Supplier wise',
          component: PharmacyPurchasesbySupplier,
          icon: faBuilding,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Returns',
      icon: faArrowRotateLeft,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      groupId: 'inventory',
      position: 7,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Return',
          component: PharmacyReturn,
          icon: faRotateLeft,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'returnlist',
          label: 'Return List',
          component: PharmacyReturnList,
          icon: faListCheck,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      groupId: 'management',
      position: 8,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: PharmacyAddEmployee,
          icon: faUserPlus,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: PharmacyEmployeeList,
          icon: faIdCard,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        }
      ]
    },
    {
      id: 'transactions',
      label: 'Transactions',
      icon: faArrowRightArrowLeft,
      roles: ['admin_pharmacy', 'admin_pharmacytax'],
      groupId: 'sales',
      position: 9,
      submenus: [
        {
          id: 'transactionsmanager',
          label: 'Transactions',
          component: PharmacyTransactionsManager,
          icon: faMoneyBillWave,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        }
      ]
    },
    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      groupId: 'inventory',
      position: 10,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: PharmacyBarcode,
          icon: faPrint,
          roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax']
        }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_pharmacy', 'admin_pharmacytax'],
      groupId: 'system',
      position: 11,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax'],
      groupId: 'system',
      position: 12,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '$2,100' },
    { id: 'products', label: 'Products', icon: 'faBoxes', value: 567 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 134 },
    { id: 'pending', label: 'Expiring Soon', icon: 'faClock', value: 23 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + C', description: 'Add Customer' },
    { key: 'Alt + L', description: 'Customer List' },
    { key: 'Alt + P', description: 'Stock List' },
    { key: 'Alt + S', description: 'New Sale' },
    { key: 'Alt + U', description: 'New Purchase' },
    { key: 'Alt + R', description: 'New Return' },
    { key: 'Alt + E', description: 'Add Employee' },
    { key: 'Alt + G', description: 'Employees List' },
    { key: 'Alt + V', description: 'Suppliers List' },
    { key: 'Alt + B', description: 'Barcode Printing' },
    { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};